import { render, staticRenderFns } from "./FranchiseeStepsCardV2.vue?vue&type=template&id=31c9d454&scoped=true&"
import script from "./FranchiseeStepsCardV2.vue?vue&type=script&lang=js&"
export * from "./FranchiseeStepsCardV2.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseeStepsCardV2.vue?vue&type=style&index=0&id=31c9d454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9d454",
  null
  
)

export default component.exports